import ParticipantsStep from "@/components/v2/create-meets/steps/participants-step";
import { Card } from "@heroui/react";
import { useMemo } from "react";

const MeetingDetailsParticipantsComp = ({ value, onChange }) => {
  const participants = useMemo(
    () =>
      (value?.members ?? []).map((m) => ({
        id: m.member_id,
        fullname: m.member_fullname,
        email_address: m.member_email,
      })),
    [value?.members],
  );

  function handleFormDataChange(patch) {
    if (patch.participants) {
      const members = patch.participants.map((p) => ({
        member_id: p.id,
        member_email: p.email_address,
        member_fullname: p.fullname,
      }));
      onChange({ members });
    }
  }

  return (
    <Card className="bg-[#FFFFFFAD] dark:bg-[#000000B2]">
      <Card.Content>
        <ParticipantsStep formData={{ participants }} updateFormData={handleFormDataChange} />
      </Card.Content>
    </Card>
  );
};

export default MeetingDetailsParticipantsComp;